import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import filterReports from "../helpers/filterReports"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    
    valueDepartment: [],
    valueMunicipality: [],
    valueLevels: [],
    valueAmenazas: [],
    valueGuild: [],
    experiencesSelected: [],
    allExperiences: [],
    experiences: [],
    filter: [],
    departamento: {},
    municipio: {},
    nivel: {},
    amenazas: {},
    gremios: {},
    objetivos: {},
    indicadores: {},
    rango: {},
    footer: {
      email: '',
      schedule: '',
      phone: ''
    }
  },
  getters: {
    getExperiences: state => {
      return state.experiences
    }
  },
  mutations: {
    filterExperiences: (state, action) => {
      const { filter } = action
      let allExperiences = _.cloneDeep(state.allExperiences)
      if (!action.id){
        state.filter = state.filter.filter((filt) => filt.filter !== action.filter)
        allExperiences = filterReports(state.filter, allExperiences)
        state.experiences = allExperiences
        return
      }
      const index = state.filter.findIndex(filt => filt.filter === filter)
      if (index !== -1) {
        state.filter[index] = action
        allExperiences = filterReports(state.filter, allExperiences)
      } else {
        state.filter = [...state.filter, action]
        allExperiences = filterReports(state.filter, allExperiences)
      }
      state.experiences = allExperiences
    }
  },
  actions: {

  }
})
